export default __webpack_public_path__ + "static/media/drag-button.62a2fb09.svg";